import { Box, Typography } from "@mui/material";
import { Controller, FieldValues, useFormContext } from "react-hook-form";
import UploadFileListItem from "../../../../../components/UploadFileListItem";

export default function EnviarAnexos() {

    const { control, getFieldState } = useFormContext();

    const InputAttachment = ({ name, label }: InputAttachmentProps) => {
       

        return (
            <Controller
                name={`enviarAnexos.${name}`}
                control={control}
                render={({ field }: FieldValues) => (
                    <UploadFileListItem
                        label={label}
                        value={field.value}
                        onChangeValue={(arquivo) => field.onChange(arquivo)}
                        error={getFieldState(`enviarAnexos.${name}`).invalid}
                    />
                )}
            />
        )
    }

    return (
        <Box mb={4}>
            <InputAttachment
                name="docIdentidade"
                label="Documento de identificação"
            />

            <InputAttachment
                name="comprovanteEnd"
                label="Comprovante de endereço"
            />

            <InputAttachment
                name="certidaoCasamento"
                label={`Certidão de casamento`}
                
            />

            <InputAttachment
                name="documentoIdConjuge"
                label={`Documento de identificação do conjuge`}
            />

            <InputAttachment
                name="cartaoProdutorRural"
                label="Cartão de Produtor Rural"
            />

            <InputAttachment
                name="docPropriedade"
                label="Documento da propriedade"
            />

            <InputAttachment
                name="declaracaoIRPF"
                label="Declaração IRPF"
            />
            
            <InputAttachment
                name="declaracaoIRPFRecibo"
                label="Declaração IRPF (Recibo)"
            />

            <InputAttachment
                name="itr"
                label="Declaração ITR (Declaração de Imposto Territorial Rural)"
            />

            <InputAttachment
                name="itrRecibo"
                label="Declaração ITR (Recibo)"
            />

            <InputAttachment
                name="ccir"
                label="CCIR (Certificado de Cadastro de Imóvel Rural)"
            />

            <InputAttachment
                name="car"
                label="CAR (Cadastro Ambiental Rural)"
            />

            <Box
                component="div"
                display="flex"
                justifyContent="flex-end"
                mt={2}
            >
                <Typography variant="caption">Limite de até 10mb por arquivo</Typography>
            </Box>

        </Box>
    )

}

interface InputAttachmentProps {
    name: string,
    label: string,
}